import { AppDatatableProcessingStatus, AppDatatableActionType } from "app/shared/datatable/enums";
import { StringAnyMap } from "app/client-core/api-interfaces/keyvalue-maps.interface";

export class AppDatatableActionEvent {

    public status: AppDatatableProcessingStatus;
    public type: AppDatatableActionType;
    public data: StringAnyMap;

    constructor(type: AppDatatableActionType, status: AppDatatableProcessingStatus,  data: StringAnyMap = {}) {
        this.status = status;
        this.type = type;
        this.data = data;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/action-event.model.ts